import { Spinner } from '@frontend/components/common';
import { FormattedMessage } from 'react-intl';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useVerifyOrderStockRequirement from './verify-order-stock-requirement.controller';

const ID = 'verify-order-stock-requirement';

const VerifyOrderStockRequirement = (props: { wizard_id: string }) => {
    const viewProps = useVerifyOrderStockRequirement(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onContinue,
        continueDisabled: !viewProps.canContinue
    });

    if (viewProps.isLoading) {
        return (
            <div
                id={ID}
                className='flex justify-center py-8'>
                <Spinner />
            </div>
        );
    }

    if (viewProps.hasRequirement) {
        return (
            <p id={ID}>
                <FormattedMessage
                    id='platform.wizard.verify-order-stock-requirement.requirement-exists'
                    description='Message shown when the ordered product has a stock requirement at the selected distriSPOT'
                    defaultMessage='This product has a stock requirement at this distriSPOT and will be filled soon.'
                />
            </p>
        );
    }

    if (viewProps.hasError) {
        return (
            <p id={ID}>
                <FormattedMessage
                    id='platform.wizard.verify-order-stock-requirement.fetch-error'
                    description='Error shown when the stock requirement for an order cannot be checked'
                    defaultMessage='The stock requirement could not be checked. Please try again later.'
                />
            </p>
        );
    }

    if (viewProps.configurationError) {
        return (
            <p id={ID}>
                <FormattedMessage
                    id='platform.wizard.verify-order-stock-requirement.configuration-error'
                    description='Error shown when the order transaction functionality has no configured colli workflow'
                    defaultMessage='This order transaction workflow is not configured with a colli workflow.'
                />
            </p>
        );
    }

    return (
        <p id={ID}>
            <FormattedMessage
                id='platform.wizard.verify-order-stock-requirement.no-requirement'
                description='Message shown when the ordered product has no stock requirement at the selected distriSPOT'
                defaultMessage='No stock requirement was found. You can continue creating the PuDo transaction.'
            />
        </p>
    );
};

export default VerifyOrderStockRequirement;
